import client from '../client';

export const readFeedbackList = ({ f_type, state, s_type, start_date, end_date, employee, content, page }) =>
    client.get(`/api/administrator/feedback`, {
        params: {
            f_type,
            state,
            s_type,
            start_date,
            end_date,
            employee,
            content,
            page,
            pagesize: 15
        }
    });

export const readFeedbackDetail = ({ id }) =>
    client.get(`/api/administrator/feedback/${id}`);

export const updateComment = ({ id, type, adminComment, userComment }) =>
    client.post(`/api/administrator/feedback/${id}`, { type, adminComment, userComment });
